import { useMemo } from 'react';

import BaseRadio from '@r1-frontend/ui-react/components/controls/baseRadio';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

export enum EAdditionalMethodId {
    sbp = 'sbp',
    newCard = 'new-card',
}

export type TPaymentMethod = 'card' | 'sbp' | 'new-card' | 'sberpay';

export interface IMethodData {
    id: string | EAdditionalMethodId,
    methodType: TPaymentMethod,
    label: string,
    value: string,
    imagePath: string,
    imageAlt: string,
    isAutoPayConnected: boolean,
    isIcon?: boolean,
    onSelectMethod?: (selectedMethod: IMethodData) => void,
    widget?: ({ isChecked, method, onSelectMethod }: IPaymentMethodProps) => JSX.Element,
    additionalBlock?: () => JSX.Element,
}

export interface IPaymentMethodProps {
    isChecked: boolean,
    method: IMethodData,
    onSelectMethod: (method: IMethodData) => void,
}

export const PAYMENT_METHOD_ID = 'PaymentMethod';

const PaymentMethod = ({ isChecked, method, onSelectMethod }: IPaymentMethodProps): JSX.Element => {
    const isTablet = useMatchMediaByWidth(wideBreakpoints.tablet);

    const { id, methodType, value, label, imagePath, imageAlt, isIcon } = method;

    const onSelectMethodHandler = ()  => {
        onSelectMethod(method);
    };

    const methodName = useMemo(() => {
        if (methodType === 'card') {
            const [paySystem, ...rest] = label.split(' ');

            return <ListContainer $desktop={0} $mobile={0} $direction='column'>
                <span>{paySystem}</span>
                <span>{rest.join(' ')}</span>
            </ListContainer>;
        }

        return label;
    }, [label, methodType]);

    return (
        <ST.ItemWrapper
            isChecked={isChecked}
            onClick={onSelectMethodHandler}
            data-test={PAYMENT_METHOD_ID}
        >
            <ST.SBlockContainer
                indent={{ $united: [0] }}
                rounder={{ $radius: 24 }}
                bgColor={COLORS.BgSurface}
                isSbp={methodType === 'sbp'}
            >
                <ST.ItemImage
                    isSbp={methodType === 'sbp'}
                    isIcon={isIcon}
                >
                    <img src={imagePath} alt={imageAlt} />
                </ST.ItemImage>
                <ST.ItemRadio>
                    <BaseRadio
                        size={isTablet ? 'XXS' : 'XS'}
                        id={id}
                        name={'method'}
                        value={value}
                        checked={isChecked}
                        data-test={`${PAYMENT_METHOD_ID}-radio`}
                    >
                        {methodName}
                    </BaseRadio>
                </ST.ItemRadio>
            </ST.SBlockContainer>
        </ST.ItemWrapper>
    );
};

export default PaymentMethod;
